import { Grid, Button, Box, ToggleButtonGroup, ToggleButton, TextField, InputAdornment } from "@mui/material";
import { ViewList, GridView, Search } from "@mui/icons-material";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import { ScreenGreeting } from "../../../Components/Molecules";
import intl from "react-intl-universal";
import { OrganizerCard } from "./Card";
import {
  useSubAccountsList,
} from "../../../Hooks/useSubAccounts";
import { useEffect, useRef, useState } from "react";
import { useToast } from "../../../Hooks/toast";
import { useEventListener } from "../../../Hooks";
import { OrganizerForm, OrginizerFormRef } from "./OrganizerForm";
import { Link } from "react-router-dom";
import { useAuth } from "../../../Contexts/AuthContext";
import OrganizerListTable from "./ListTable";



type ViewMode = 'grid' | 'list';

export function Organizers() {
  

  const organizerFormRef = useRef<OrginizerFormRef>(null);

  const { hasPermission } = useAuth();

  const {
    handleGET: fetchSubAccountsGET,
    loading,
    state: subAccounts,
  } = useSubAccountsList();

  const viewModeKey = '@Organizers:viewMode';
  const [viewMode, setViewMode] = useState<ViewMode>(() => {
    try {
      const stored = localStorage.getItem(viewModeKey);
      return stored === 'grid' || stored === 'list' ? (stored as ViewMode) : 'grid';
    } catch {
      return 'grid';
    }
  });

  const [search, setSearch] = useState<string>("");

  useEffect(() => {
    fetchSubAccountsGET({});
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem(viewModeKey, viewMode);
    } catch {}
  }, [viewMode]);

  const normalize = (v: string) =>
    (v || "")
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();

  const filteredSubAccounts = Array.isArray(subAccounts)
    ? subAccounts.filter((s) => {
        const haystack = normalize([
          s.name,
          s.idCustomer,
          s.subAccountId,
          s.isActive ? 'ativo' : 'inativo',
          String(s.available ?? '')
        ].join(' '));
        const needle = normalize(search);
        return needle.length === 0 || haystack.includes(needle);
      })
    : [];

  return (
    <>
      
      <ScreenGreeting
        title={intl.get(`words.organizers`)}
        subTitle="Faça o gerenciamento dos seus pontos de venda com facilidade."
      />

      <OrganizerForm
        onSucess={() => fetchSubAccountsGET({})}
        ref={organizerFormRef}
      />
      {
        hasPermission('subaccountcreate') && (
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddBusinessIcon />}
            sx={{ mb: 2, color: '#fff' }}
            onClick={() => organizerFormRef.current.openOrganizer({ name: '', subAccountId: '', isActive: true })}
          >
            Criar Ponto de Venda
          </Button>
        )
      }

      <Box display="flex" alignItems="center" justifyContent="space-between" mb={2} gap={2}>
        <TextField
          fullWidth
          label="Buscar"
          value={search}
          size="small"
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Digite para filtrar..."
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Search fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
        <ToggleButtonGroup
          size="small"
          color="primary"
          value={viewMode}
          exclusive
          onChange={(_, value) => value && setViewMode(value)}
          aria-label="modo de visualização"
        >
          <ToggleButton value="grid" aria-label="grade">
            <GridView fontSize="small" />
            <Box component="span" ml={0.5}>Cards</Box>
          </ToggleButton>
          <ToggleButton value="list" aria-label="lista">
            <ViewList fontSize="small" />
            <Box component="span" ml={0.5}>Lista</Box>
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {viewMode === 'grid' ? (
        <Grid container spacing={2}>
          {Array.isArray(subAccounts) &&
            (filteredSubAccounts.length === 0 ? (
              search ? (
                <p> Nenhum resultado para "{search}". </p>
              ) : (
              <p> Não há organizador cadastrado. </p>
            )) : (
              filteredSubAccounts.map((subAccount, i) => (
                <Grid item key={subAccount.subAccountId}>
                  {
                    hasPermission('subaccountcreate') ? (
                      <Link
                        to={`/pontos-de-venda/${subAccount.subAccountId}`}
                      >
                        <OrganizerCard
                          key={i}
                          name={subAccount.name}
                          idCustomer={subAccount.idCustomer}
                          upperBarColor="#36D9FF"
                          statusColor={subAccount.isActive ? '#4CB592' : '#dc3545'}
                          totalValue={subAccount.available}
                          highlight={search}
                        />
                      </Link>
                    ) : (
                        <OrganizerCard
                          key={i}
                          name={subAccount.name}
                          idCustomer={subAccount.idCustomer}
                          upperBarColor="#36D9FF"
                          statusColor={subAccount.isActive ? '#4CB592' : '#dc3545'}
                          totalValue={subAccount.available}
                          highlight={search}
                        />
                    )
                  }

                </Grid>
              ))
            ))}
        </Grid>
      ) : (
        <OrganizerListTable
          data={filteredSubAccounts}
          emptyMessage={search ? `Nenhum resultado para "${search}".` : 'Não há organizador cadastrado.'}
          canNavigate={hasPermission('subaccountcreate')}
          highlight={search}
        />
      )}
    </>
  );
}
